import { Injectable } from '@angular/core';
import { AnalyticsEventTrackerFactory } from './analytics-factory';
import { BehaviorSubject, of, tap, from } from 'rxjs';
import { v4 as uuidv4 } from 'uuid';
import { DataLayerEvent } from '../../models/data-layer-event.model';
import { environment } from 'src/environments/environment';

declare const window: any;

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {

  private db: any;

  constructor(private analyticsEventTrackerFactory: AnalyticsEventTrackerFactory) {
    window.dataLayer = window.dataLayer || [];
  }

  saveDataLayerEvent(eventName: string, eventData: any) {
    if (!eventName || !eventData) return of('');
    if (!window.navigator.onLine) {
      // Save to IndexedDB when offline
      const id = uuidv4();
      const timestamp = new Date().getTime();
      const event: DataLayerEvent = { id, eventName, eventData, timestamp };
      return from(this.db.events.add(event)).pipe(
        tap(() => {
          console.log('Event saved to IndexedDB');
        })
      );
    } else {
      console.log("Event saved");
      // Push directly to dataLayer when online
      window.dataLayer = window.dataLayer || [];

      // ecommerce events require a different dataLayer structure
      if (eventData.ecommerce) {
        window.dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object (if any
        console.log(eventName);
        console.log(eventData);
        console.log({ event: eventName, ...eventData.ecommerce });
        window.dataLayer.push({
          event: eventName,
          ...eventData.ecommerce,
        });
        //this.javascriptInterfaceService.logEvent(eventName, eventData);
        return of('');
      }
      // all other events
      console.log({ event: eventName, ...eventData });
      window.dataLayer.push({ event: eventName, ...eventData });
      //this.javascriptInterfaceService.logEvent(eventName, eventData);
      return of('');
    }
  }


  trackEvent(eventName: string, eventData: any) {
    try {
      //console.log(eventData);
      if (environment.enable_analytics) {
        const eventTracker = this.analyticsEventTrackerFactory.createEvent(eventName);
        const data = eventTracker.getProcessedData(eventData);
        this.saveDataLayerEvent(eventName, data.eventData).subscribe();
      }
    } catch (error) {
      console.log(error);
      console.log('Event not tracked:', eventName, eventData);
    }
  }

}
